import { yellowOrangeRedPalette } from "@appretio/shared";
import { InSeasonReviewRow } from "../hooks/useAccuracyChartOptions";
import * as style from "./StyleOptionAccuracyTooltip.css";

export function StyleOptionAccuracyTooltip(row: InSeasonReviewRow) {
  const pictureUrl = row.appretio_picture_url ?? "";
  const styleName = row.style_name ?? "";
  const optionId = row.style_option_id_mockup ?? "";
  const nis3Value = row.nis3 ?? 0;
  const timeValue = row.time_purchase ?? 0;
  const week_zero_50_st = row.week_zero_50_st ?? 0;
  const colorBar = yellowOrangeRedPalette(week_zero_50_st);

  return `
    <div class="${style.tooltipWrapper}" role="tooltip" aria-label="Product summary">
      <img
        class="${style.image}"
        src="${pictureUrl}"
        alt="${styleName ? `${styleName} image` : "Product image"}"
        loading="lazy"
        onerror="this.style.display='none'"
      />
      <div class="${style.contentContainer}">
        <div class="${style.grid}">
          <span class="${style.rowTitle}">Style Option:</span>
          <span class="${style.rowValue}">${optionId}</span>
        </div>
        <div class="${style.grid}">
          <span class="${style.rowTitle}">Style Name:</span>
          <span class="${style.rowValue}">${styleName}</span>
        </div>
        <dl class="${style.grid}">
          <div class="${style.gridRow}">
            <dt class="${style.rowTitle}">NIS III:</dt>
            <dd class="${style.rowValue}">${nis3Value}</dd>
          </div>
          <div class="${style.gridRow}">
            <dt class="${style.rowTitle}">Time purchase:</dt>
            <dd class="${style.rowValue}">${timeValue}</dd>
          </div>
        </dl>
        <div class="${style.barWrap}" aria-label="color scale">
          <div class="${style.bar}" style="background:${colorBar}"></div>
        </div>
      </div>
    </div>
  `;
}
